import { useEffect, useState } from 'react';
import ClientSelect from './Select/ClientSelect';
import {
    Box,
    Grid,
    TextField,
    Card,
    CardHeader,
    CardContent,
  } from '@mui/material';
import { PermissionsGate } from 'components/authorization/PermissionsGate';
import { SCOPES } from 'common/permissions';
import RequiredField from '../../common/RequiredField';
import intl from 'components/i18n/ReactIntlWrapper';

const ProjectForm = ({ errors, input, handleInputChange, handleClientChange, clients, selectedClient, disabled, idProject, setErrors, validate }) => {
    const [jiraToken, setJiraToken] = useState(input.jiraToken == '**encrypted**' ? '**encrypted**' : input.jiraToken);
    const [jiraTokenInputFlag, setJiraTokenInputFlag] = useState(false);
    const [jiraTokenFlag, setJiraTokenFlag] = useState(false);

    useEffect(() => {
        if (!disabled) {
            setJiraToken(input.jiraToken == '**encrypted**' ? '' : input.jiraToken);
        }
        else {
            setJiraToken(input.jiraToken == '' ? '' : input.jiraToken);
        }
        setJiraTokenInputFlag(input.jiraToken === "" || input.jiraToken === null ? true : jiraTokenFlag);

    }, [disabled, input, jiraTokenFlag]);

    const handleJiraTokenChange = (e) => {
        setJiraToken(e.target.value);
        handleInputChange(e);
        setJiraTokenFlag(true);
    }

    const handleJiraTokenTextChange = (e) => {
        if (e.keyCode == 8 || e.keyCode == 46) {
            input.jiraToken = "";
            setJiraTokenFlag(true);
            setErrors(validate({
                ...input,
                "jiraToken": ""
            }));
        }
    }

    return (
          <Box component="form" sx={{ my: 4 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 4 }}>
            <TextField
              fullWidth
              id="name"
              name="name"
              label={intl.get('projectForm.name')}
              placeholder={intl.get('projectForm.placeholder.name')}
              value={input.name}
              onChange={handleInputChange}
              disabled={disabled}
              error={!!errors.name}
              helperText={errors.name}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }}>
            <ClientSelect
              handleClientChange={handleClientChange}
              clients={clients}
              selectedClient={selectedClient}
              disabled={disabled}
              errors={errors}
              enableEdit={!!idProject}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <PermissionsGate
              viewScopes={[SCOPES['budget.read']]}
              editScopes={[SCOPES['budget.edit']]}
              viewRoles={[]}
              editRoles={[]}
            >
              <TextField
                fullWidth
                type="number"
                id="budget"
                name="budget"
                label={'* ' + intl.get('projectForm.budget')}
                placeholder={intl.get('projectForm.placeholder.budget')}
                value={input.budget}
                onChange={handleInputChange}
                disabled={disabled}
                error={!!errors.budget}
                helperText={errors.budget}
              />
            </PermissionsGate>
          </Grid>

          <Grid size={{ xs: 12 }}>
            <RequiredField />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Card variant="outlined">
              <CardHeader title={intl.get('projectForm.jira.header')} />
              <CardContent>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      id="jiraUser"
                      name="jiraUser"
                      label={intl.get('projectForm.jira.user')}
                      placeholder={intl.get('projectForm.jira.placeholder.user')}
                      value={input.jiraUser || ''}
                      onChange={handleInputChange}
                      disabled={disabled}
                      error={!!errors.jiraUser}
                      helperText={errors.jiraUser}
                      autoComplete="off"
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      type={disabled ? 'password' : 'text'}
                      id="jiraToken"
                      name="jiraToken"
                      label={intl.get('projectForm.jira.access')}
                      placeholder={intl.get('projectForm.jira.placeholder.access')}
                      value={jiraTokenInputFlag ? jiraToken : input.jiraToken}
                      onChange={jiraTokenInputFlag ? handleJiraTokenChange : undefined}
                      onKeyDown={!jiraTokenInputFlag ? handleJiraTokenTextChange : undefined}
                      disabled={disabled}
                      error={!!errors.jiraToken}
                      helperText={errors.jiraToken}
                      autoComplete="off"
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      id="jiraProjectKey"
                      name="jiraProjectKey"
                      label={intl.get('projectForm.jira.projectKey')}
                      placeholder={intl.get('projectForm.jira.placeholder.projectKey')}
                      value={input.jiraProjectKey || ''}
                      onChange={handleInputChange}
                      disabled={disabled}
                      error={!!errors.jiraProjectKey}
                      helperText={errors.jiraProjectKey}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                      fullWidth
                      id="jiraUrl"
                      name="jiraUrl"
                      label={intl.get('projectForm.jira.url')}
                      placeholder={intl.get('projectForm.jira.placeholder.url')}
                      value={input.jiraUrl || ''}
                      onChange={handleInputChange}
                      disabled={disabled}
                      error={!!errors.jiraUrl}
                      helperText={errors.jiraUrl}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
    </Box>
        );
}

export default ProjectForm;